declare global {
    interface Window { dataLayer: any[] }
}

function push(event: string, data?: Record<string, any>) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
}

export function trackBookingStep(booking: Booking) {
    push('flow_booking_step', {
        booking_step: booking.page,
        booking_flow: booking.booking_flow,
        car_brand: booking.car.brand || undefined,
        service_name: booking.service.name || undefined,
    });
}

export function trackBookingComplete(order: any) {
    push('flow_booking_complete', {
        booking_flow: order.booking.booking_flow,
        car_brand: order.booking.car.brand || undefined,
        service_name: order.service.name || undefined,
        // Verkstaden (service_centers.slug). booking.submission är hur bilen
        // lämnas in, t.ex. pa-morgonen, och var fel källa här.
        workshop_slug: order.service.place?.slug || undefined,
        order_number: order.order_number || undefined,
    });
}
